import React, { useState } from "react";
import { useParams, useHistory, useLocation, Link } from "react-router-dom";
import { LuFile, LuImage, LuList, LuSearch } from "react-icons/lu";
import { IoIosArrowBack } from "react-icons/io";

function PdfViewer({ src }) {
  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      <embed
        src={`${src}#toolbar=0&navpanes=0&scrollbar=0`}
        type="application/pdf"
        width="100%"
        height="100%"

      />
    </div>
  );
}

const DrawingDetailView = () => {
  const { folder_path, imageName } = useParams();
  const history = useHistory();
  const location = useLocation();
  const { files } = location.state || {};
  const [activeTab, setActiveTab] = useState("Drawings");


  const images = {
    Img1: files[0]?.image_sets?.Drawing || [],
    Img2: files[0]?.image_sets?.["Balloon Images"] || [],
    Img3: files[0]?.image_sets?.Summary || [],
    Img4: files[0]?.image_sets?.Inspection || [],

  };
  const tabs = [
    { name: "Drawings", icon: <LuFile /> },
    { name: "Balloon Images", icon: <LuImage /> },
    { name: "Summary", icon: <LuList /> },
    { name: "Inspection", icon: <LuSearch /> },
  ];


  const renderContent = () => {
    const renderImageList = (imgArray) => {
      if (!imgArray?.length) {
        return (
          <div className="flex justify-center items-center text-center text-gray-500  ">
            No Images Available
          </div>
        );
      }

      return (
        <div className="flex flex-wrap justify-center gap-6 p-4 ">
          {imgArray.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`Image ${index + 1}`}
              className="h-[79vh] w-full flex-grow  rounded-lg border border-gray-300 shadow-sm hover:shadow-md transition "
            />
          ))}
        </div>
      );
    };

    switch (activeTab) {
      case "Drawings":
        return renderImageList(images.Img1);

      case "Balloon Images":
        return renderImageList(images.Img2);

      case "Summary":
        return <PdfViewer src={images.Img3} />
      case "Inspection":
        return (
          <div className="flex  items-center gap-2 justify-center h-full  ">
            <p className="text-bold "> To Download Inspection Report </p>
            <Link
              onClick={() => {
                const link = document.createElement("a");
                link.href = images.Img4;
                link.download = "Inspection_Report.pdf";
                link.click();
              }}
              className=" text-blue-500   text-bold  hover:text-blue-800 hover:border-b-2 border-blue-800 transition-all duration-200"
            >
              Click here
            </Link>
          </div>
        );
      default:
        return (
          <div className="flex justify-center items-center text-center text-gray-500 h-full py-20">
            No Data Available
          </div>
        );
    }
  };

  return (
    <div className="  h-full">
      <div className="flex flex-row items-center   ">
        <div className="flex items-center   ">
          <h2 className="text-xl text-gray-600 font-medium cursor-pointer "
            onClick={() =>
              history.push({
                pathname: "/Drawingsbollon",
                state: { files },
              })
            }
          >
            <IoIosArrowBack fontSize={30} />
          </h2>
        </div>
        <div className="relative flex justify-around items-center w-full px-12">
        
          <div
            className="
    absolute top-1/2 
    left-6 right-6 sm:left-16 sm:right-16 lg:left-36 lg:right-32 
    h-[2px] bg-gray-300 -translate-y-1/2 z-0
  "
          ></div>
          {tabs.map((tab, index) => (
            <div key={tab.name} className="relative z-10 flex flex-col items-center ">
              <button
                onClick={() => setActiveTab(tab.name)}
                className={`relative flex items-center justify-center w-12 h-12 rounded-md shadow-lg shadow-slate-500 transition-all duration-300
                  ${activeTab === tab.name
                    ? "bg-orange-400 text-white"
                    : "bg-gray-200 text-gray-600"
                  }
                before:content-[''] before:absolute before:w-full before:h-full before:bg-inherit 
                before:top-0 before:left-0 before:-z-10 before:[clip-path:polygon(10%_0,90%_0,100%_100%,0%_100%)]`}
                style={{
                  transform: "rotate(-5deg)",
                }}
              >
                <span className="text-lg">{tab.icon}</span>
              </button>
              <span className="mt-1 text-sm font-medium text-gray-700 ">
                {tab.name}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Content Area */}
      <div style={{ height: "72vh" }}>{renderContent()}</div>
    </div>
  );
}

export default DrawingDetailView;
